import React from 'react';

const ContentText = ({ children, extraClassName }) => (
  <p className={`promos promos-text ${extraClassName? extraClassName : ''}`}>
    {children}
  </p>
);

export default ContentText;
